/**
 * Service do Controle de Cheques (FIN-8 — ADR-0042).
 * Consome /api/cheques (CRUD-leitura + actions de transição).
 */
const PREFIXO = "/api/cheques";

function _post(request, url, dados) {
  return request(url, { method: "POST", body: JSON.stringify(dados || {}) });
}

export function listarCheques(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.situacao) usp.set("situacao", params.situacao);
  if (params.busca) usp.set("busca", params.busca);
  const qs = usp.toString();
  return request(`${PREFIXO}${qs ? `?${qs}` : ""}`);
}

export function obterResumoCheques(request) {
  return request(`${PREFIXO}/resumo`);
}

export function criarCheque(request, dados) {
  return _post(request, PREFIXO, dados);
}

export function depositarCheque(request, id, dados = {}) {
  return _post(request, `${PREFIXO}/${id}/depositar`, dados);
}

export function compensarCheque(request, id, dados = {}) {
  return _post(request, `${PREFIXO}/${id}/compensar`, dados);
}

export function repassarCheque(request, id, dados) {
  return _post(request, `${PREFIXO}/${id}/repassar`, dados);
}

export function devolverCheque(request, id, dados = {}) {
  return _post(request, `${PREFIXO}/${id}/devolver`, dados);
}

export function sustarCheque(request, id, dados = {}) {
  return _post(request, `${PREFIXO}/${id}/sustar`, dados);
}
